<script setup>
    import { onMounted, ref, reactive } from 'vue';
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import BaseIcon from "@/Components/BaseIcon.vue";
    import CardBoxModal from "@/Components/CardBoxModal.vue";
    import {
        mdiEye, mdiCog, mdiArrowUpCircle, mdiArrowDownCircle, mdiArrowDownBold, mdiClipboardEdit, mdiCashPlus, mdiPlusCircle, mdiInformationOutline
    } from "@mdi/js";
    import VueCal from "vue-cal";
    import 'vue-cal/dist/vuecal.css'
    import CardBox from "@/Components/CardBox.vue";
    import TableAdvanced from "@/Components/TableAdvanced.vue";
    import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
    import CardBoxComponentLoad from '@/Components/CardBoxComponentLoad.vue';
    import BaseButtons from "@/Components/BaseButtons.vue";
    import BaseButton from "@/Components/BaseButton.vue";
    import CardBoxWidget from "@/Components/CardBoxWidget.vue";
    import SectionTitleLineWithButton from "@/Components/SectionTitleLineWithButton.vue";
    //import SectionTitleLineWithButtonUnens from "@/Components/SectionTitleLineWithButtonUnens.vue";// <-- Cambios para agregar más contenido
    import LineChart from "@/Components/Charts/LineChart.vue";
    import BarChart from "@/Components/Charts/BarChart.vue";
    import NotificationAlert from "@/Components/NotificationAlert.vue";
    import BreezeDropdown from '@/Components/Dropdown.vue';
    import BreezeDropdownLink from '@/Components/DropdownLink.vue';
    //import RadarChart from "@/Components/Charts/RadarChart.vue";// Example <-- cambiar a sólo RadarChart y no Example
    // Pruebas
    //import * as chartConfig from "@/Components/Charts/chart.config.js";

    // Formulario
    import BreezeLabel from '@/Components/Label.vue';
    import BreezeInput from '@/Components/Input.vue';

    // Section Configuration
    import FormField from "@/Components/FormField.vue";
    import FormControl from "@/Components/FormControl.vue";
    import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
    import { Inertia } from '@inertiajs/inertia';
    import VueSelect from "vue3-select-component";

    const props = defineProps({
        actioncontrol: {
            type: String,
            default: 'view'
        },
        titleup: String,
        classrooms: Object,
        classroomsTutor: Object,
        classroomsCoord: Object,
        events: Array,
        isAdmin: Boolean,
        isAdminCoord: Boolean,
        isCoord: Boolean,
        isTutor: Boolean,
        isPsico: Boolean,
        isSecre: Boolean,
        coursesComp: Array,
        anioEscolar: String,
        students: Array,
        allStudents: Array,
        studentBecados: Array,
        studentCompromisoPago: Array,
        studentPensionPref: Array,
        orderPtePagos: Number,
        orderPtePagosRet: Number,
        orderFacturado: Number,
        orderNoFacturado: Number,
        factureAceptado: Number,
        factureEnviado: Number,
        factureObservado: Number,
        confConst: Object,
        studentsPtePagosRet: Number,
        studentsDisabledAcces: Number,
        listStudentsPtePagosRet: Array,
        arrayDeudores: Array,
        arrayDeudoresCol: Array,
        userParamDeudores: Object,
        message: String
    });

    const action = ref(props.actioncontrol) // Los props son de lectura así que en el template se haré cambios al action segúnn el click a cada boton
    const tab = ref((props.isAdmin ? 0 : 4))

    if (action.value == 'view_estados_cuenta') {
        tab.value = 1
    }

    //console.log(props.listStudentsPtePagosRet)

    const pinSecurity = ref('')
    const msg1 = ref('')
    const navigatorVersion = ref('')
    const navigatorName = ref('')
    onMounted(() => {
        //console.log(msg)
        // msg1.value = msg
        if (action.value == 'view_estados_cuenta') {
            listarOrdenPago()
        }
        listarChartOrdenes()
        navigatorVersion.value = navigator.appVersion
        navigatorName.value = navigator.appName
    });

    const chartOrdenes = ref(null)// <-- Estaba en Array y generaba error con un labels y datasets adicionales
    /* onMounted(() => {
        listarChartCalification()
    }); */
    const chartPendientes = ref(null)
    const listarChartOrdenes = () => {
        //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
        let url = '/payementOrder/grafica';

        axios.get(url).then(function (response) {
            let respuesta = response.data;
            chartOrdenes.value = respuesta.chartCuentasTodas// El return directo del array trae otros datos que generan error para el chart
            chartPendientes.value = respuesta.chartPendientes
            //chartOrdenes.value = chartConfig.sampleChartData();
            console.log(chartOrdenes.value);
        }).catch(function (error) {
            console.log(error);
        });
    }

    // Info de calendar
    const selectedEvent = ref({})
    const showDialog = ref(false)
    const pruebaevents = [
        { id: 1, start: '2023-04-19 12:00', end: '2023-04-19 13:00', title: 'Más trabajo, está bien 1', content: '', contentFull: 'My shopping list is rather long:<br><ul><li>Avocados</li><li>Tomatoes</li><li>Potatoes</li><li>Mangoes</li></ul>', class: 'leisure', deletable: 1 },
        { id: 2, start: '2023-04-20 12:00', end: '2023-04-23 17:00', title: 'Más trabajo, está bien 2', content: 'es mejor que halla más trabajo 2', contentFull: 'My shopping list is rather long:<br><ul><li>Avocados</li><li>Tomatoes</li><li>Potatoes</li><li>Mangoes</li></ul>', class: 'sport', split: 1 },
        { id: 3, start: '2023-04-20 12:00', end: '2023-04-21 14:00', title: 'Más trabajo, está bien 3', content: 'es mejor que halla más trabajo 3', contentFull: 'My shopping list is rather long:<br><ul><li>Avocados</li><li>Tomatoes</li><li>Potatoes</li><li>Mangoes</li></ul>', class: 'leisure', allday: 1 },
        { id: 4, start: '2023-04-17 12:00', end: '2023-04-18 13:00', title: 'Más trabajo, está bien 4', content: 'es mejor que halla más trabajo 4', contentFull: 'My shopping list is rather long:<br><ul><li>Avocados</li><li>Tomatoes</li><li>Potatoes</li><li>Mangoes</li></ul>', class: 'sport', resizable: 1 }
    ]
    const onEventClick = (event, e) => {
        selectedEvent.value = event
        showDialog.value = true
        // Prevent navigating to narrower view (default vue-cal behavior).
        e.stopPropagation()
    }

    // Infor de Aulas y curso   
    const data = {
        "estudiante_curso": [
            { "id": 1, "codigo": "2205", "name": "Primero - B", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "" },
            { "id": 2, "codigo": "2205-BIOLO", "name": "Tercero - D", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "última fecha de entrega de trabajos este viernes ..." },
            { "id": 3, "codigo": "2205-FISICA", "name": "Cuarto - A", "tarea": "2/2 (FL 12/10/2022)", "anuncio": "Entrega de trabajo grupal hasta el martes" },
            { "id": 4, "codigo": "2205-QUIMICA", "name": "Segundo - A", "tarea": "4/4 (FL 12/10/2022)", "anuncio": "" },
            { "id": 5, "codigo": "2205-HISTO", "name": "Primero - C", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "" },
        ]
    };

    const viewCourses = ref([])
    const viewStudents = ref([])
    
    /* if (props.isAdmin) {
        tab.value = 0
    } */

    /* const arrayPensionPreferencial = ref([])
    const arrayBecados = ref([])
    const listarStadisticOrder = () => {

    } */

    const arrayFacture = ref([]);
    const arrayFactureCol = ref([]);
    const userParamFacture = ref(null);
    const listarFacture = () => {
        //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
        // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
        let url = '/facture';
        axios.get(url).then(function (response) {
            let respuesta = response.data;
            arrayFacture.value = respuesta.datalist;
            arrayFactureCol.value = respuesta.columnas;
            userParamFacture.value = respuesta.userParam;
            console.log('Facture ' + props.message);
            //console.log(arrayOrdenPago.value);
        }).catch(function (error) {
            console.log(error);
        });
    }

    const arrayOrdenPago = ref([]);
    const arrayOrdenPagoCol = ref([]);
    const userParamOrdenPago = ref(null);
    const listarOrdenPago = () => {
        //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
        // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
        let url = '/payementOrder';
        if (tab.value == 2 && idStudentOrder.value > 0) url = '/payementOrder'+'?id_student_order='+idStudentOrder.value;

        axios.get(url).then(function (response) {
            let respuesta = response.data;
            arrayOrdenPago.value = respuesta.datalist;
            arrayOrdenPagoCol.value = respuesta.columnas;
            userParamOrdenPago.value = respuesta.userParam;
            console.log('OrdenaPago ' + props.message);
            //console.log(arrayOrdenPago.value);
        }).catch(function (error) {
            console.log(error);
        });
    }

    const showCrearOrden = ref(false)
    const showUpdateOrden = ref(false)
    const orderAnio = ref(props.anioEscolar)
    const matriculaFVencimiento = ref('')
    const order03 = ref(false)
    const order04 = ref(false)
    const order05 = ref(false)
    const order06 = ref(false)
    const order07 = ref(false)
    const order08 = ref(false)
    const order09 = ref(false)
    const order10 = ref(false)
    const order11 = ref(false)
    const order12 = ref(false)
    const order13 = ref(false)
    
    const showCrearOrdenVarios = ref(false)
    const tipoDeOrder = ref(0)
    const idOrderOrigen = ref(0)
    const fechaEmision = ref()
    const fechaVencimiento = ref('')
    const orderVariosLabel = ref('')
    const orderVariosAmount = ref(0)
    const errorOrderVarios = ref('')

    //fechaEmision.value = new Date().toLocaleDateString('en-CA')
    //fechaVencimiento.value = new Date().toLocaleDateString('en-CA')

    /* const formOrdenPago = {
        id_student: 0,
        //ref: '',
        periodo: '',
        label: '',
        fecha_emision: props.nowDate,
        fecha_vencimiento: '',
        //title: props.course.label + ' (A)',
        title: '(A)',
        content: '',
        
        percent: -1

    }; */
    const idStudentOrder = ref(0);
    const iniciarOrdenPago = (matricula = 0, pInicial = 0,) => {

        const newArr = [];
        const newArrPeriodo = [];
        const arr = props.students
        if (idStudentOrder.value > 0) {
            newArr.push({
                id_student: idStudentOrder.value,
                
            });
        } else {
            arr.forEach((student) => {
                newArr.push({
                    id_student: student.id,
                    //id_course: formDiario.id_course,
                    /* total_ttc: formDiario.id_classroom,
                    asistencia: formDiario.asistencia,
                    title: formDiario.title,
                    content: formDiario.content,
                    fecha: formDiario.fecha,
                    percent: formDiario.percent */
                });
            });
        }
        
        // Periodos
        if (order03.value) {
            newArrPeriodo.push('03')
        }
        if (order04.value) {
            newArrPeriodo.push('04')
        }
        if (order05.value) {
            newArrPeriodo.push('05')
        }
        if (order06.value) {
            newArrPeriodo.push('06')
        }
        if (order07.value) {
            newArrPeriodo.push('07')
        }
        if (order08.value) {
            newArrPeriodo.push('08')
        }
        if (order09.value) {
            newArrPeriodo.push('09')
        }
        if (order10.value) {
            newArrPeriodo.push('10')
        }
        if (order11.value) {
            newArrPeriodo.push('11')
        }
        if (order12.value) {
            newArrPeriodo.push('12')
        }
        if (order13.value) {
            newArrPeriodo.push('13')
        }

        //let ruta = 'payementOrder-registrar'
        if (newArr.length) {

            let formOrdenPago = {
                'anioOrden': orderAnio.value,
                'arrayPeriodo': newArrPeriodo,
                'arrayData': newArr,
                'matriculaFVencimiento': matriculaFVencimiento.value
            };

            let url = '/payementOrder/registrar';
            axios.post(url, formOrdenPago).then((response) => {
                let respuesta = response.data;
                //arrayOrdenPago.value = respuesta.datalist;
                //arrayOrdenPagoCol.value = respuesta.columnas;
                if (respuesta.success) {
                    //alertaSubida.value = 1;
                    //mensajes.value = 'Total registros : '+(data.total-1)+'\nRegistrados : '+data.registered+'\nActualizados : '+data.updated;
                    //limpiarVal(5000);
                    //messageAlert.value = respuesta.data.message
                    showAlert(respuesta.message, 'success', 4)
                    //console.log(response)
                    
                } else {
                    showAlert(respuesta.message, 'danger', 16)
                    //alertaSubida.value = 2;
                    //mensajes.value = respuesta.data.message;
                    //limpiarVal(3000);
                    
                }
                
                console.log('Hola ok');
                //console.log(arrayOrdenPago.value);
            }).catch((error) => {
                console.log(error);
                
            });

            //console.log(newArr)
            //if (!props.debugDisableRefreshInertia) Inertia.reload({ only: ['diarios']})

        }

    }

    const iniciarOrdenPagoVarios = () => {

        let id_student = idStudentOrder.value
        let fecha_emision = fechaEmision.value
        let fecha_vencimiento = fechaVencimiento.value
        let label = orderVariosLabel.value
        let amount = orderVariosAmount.value
        let typeOrder = tipoDeOrder.value
        let idOrderOrigin = idOrderOrigen.value

        if (id_student && label && amount) {
            let formOrdenPago = {
                'id_student': id_student,
                'fecha_emision': fecha_emision,
                'fecha_vencimiento': fecha_vencimiento,
                'label': label,
                'amount': amount,
                'tipo_de_order': typeOrder,
                'id_order_origen': idOrderOrigin
            };

            let url = '/payementOrder/registrarvarios';
            axios.post(url, formOrdenPago).then((response) => {
                let respuesta = response.data;
                //arrayOrdenPago.value = respuesta.datalist;
                //arrayOrdenPagoCol.value = respuesta.columnas;
                if (respuesta.success) {
                    showAlert(respuesta.message, 'success', 4)
                    cleanVal()
                    if (typeOrder == 1) arrayOrdenPago.value = []
                    //console.log(response)
                } else {
                    showAlert(respuesta.message, 'danger', 16)
                }
                console.log('response payement varios');
                //console.log(arrayOrdenPago.value);
            }).catch((error) => {
                console.log(error);
                
            });
        } else {
            errorOrderVarios.value = 'Error'
        }

    }

    const cleanVal = () => {

        showCrearOrden.value = false
        
        showUpdateOrden.value = false
        order03.value = false
        order04.value = false
        order05.value = false
        order06.value = false
        order07.value = false
        order08.value = false
        order09.value = false
        order10.value = false
        order11.value = false
        order12.value = false
        order13.value = false
        messageLastAction.value = ''
        messageError.value = ''
        idStudentOrder.value = 0
        pinSecurity.value = ''

        tipoDeOrder.value = 0
        idOrderOrigen.value = 0
        showCrearOrdenVarios.value = false
        orderVariosLabel.value = ''
        orderVariosAmount.value = 0
        errorOrderVarios.value = ''
        //fechaEmision.value = new Date().toLocaleDateString('es-PE')
        //fechaVencimiento.value = new Date().toLocaleDateString('es-PE')
    }

    // Sección diario de asistencia
    const arrayDiario = ref([]);
    const arrayDiarioCol = ref([]);
    const listarDiario = () => {
        //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
        // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
        let url = '/diario';
        axios.get(url).then(function (response) {
            let respuesta = response.data;
            arrayDiario.value = respuesta.diarios;
            arrayDiarioCol.value = respuesta.columnas;
            //console.log(arrayDiario.value);
        }).catch(function (error) {
            console.log(error);
        });
    }

    // Sección califaciones
    const arrayCalification = ref([]);
    const arrayCalificationCol = ref([]);
    const arrayCalificationCourses = ref([]);
    const listarCalification = () => {
        //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
        // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
        let url = '/calification';
        axios.get(url).then(function (response) {
            let respuesta = response.data;
            arrayCalification.value = respuesta.datalist;
            arrayCalificationCol.value = respuesta.columnas;
            arrayCalificationCourses.value = respuesta.select1;
            //console.log(arrayCalification.value);
        }).catch(function (error) {
            console.log(error);
        });
    }

    // Sección Admisión puntajes
    const arrayAdmisionPuntaje = ref([]);
    const arrayAdmisionPuntajeCol = ref([]);
    const listarAdmisionPuntaje = () => {
        //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
        // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
        let url = '/admisionpuntaje';
        axios.get(url).then(function (response) {
            let respuesta = response.data;
            arrayAdmisionPuntaje.value = respuesta.datalist;
            arrayAdmisionPuntajeCol.value = respuesta.columnas;
            //console.log(arrayAdmisionPuntaje.value);
        }).catch(function (error) {
            console.log(error);
        });
    }

    // Sección Subir archivos de forma general
    const arrayFileResources = ref([]);
    const arrayFileResourcesCol = ref([]);
    const listarFileResources = () => {
        //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
        // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
        let url = '/document/file_resourceforcourse';
        axios.get(url).then((response) => {
            let respuesta = response.data;
            arrayFileResources.value = respuesta.datalist;
            arrayFileResourcesCol.value = respuesta.columnas;
            //console.log(arrayFileResources.value);
        }).catch((error) => {
            console.log(error);
        });
    }

    /* const buscarInWeb = () => {
    
        var search = prompt("Termino de busqueda:");
        if (search == null || search == "") {
            alert("User cancelled");
        } else {
            find(search)
        }

    } */

    const textSearch = ref('')
    var TRange = null;

    const buscarInWeb = (str) => {
        if (parseInt(navigatorVersion.value) < 4) return;
        var strFound;
        if (window.find) {

            // CODE FOR BROWSERS THAT SUPPORT window.find

            strFound = self.find(str);
            if (!strFound) {
                strFound = self.find(str, 0, 1);
                while (self.find(str, 0, 1)) continue;
            }
        }
        else if (navigatorName.value.indexOf("Microsoft") != -1) {

            // EXPLORER-SPECIFIC CODE

            if (TRange != null) {
                TRange.collapse(false);
                strFound = TRange.findText(str);
                if (strFound) TRange.select();
            }
            if (TRange == null || strFound == 0) {
                TRange = self.document.body.createTextRange();
                strFound = TRange.findText(str);
                if (strFound) TRange.select();
            }
        }
        else if (navigatorName.value == "Opera") {
            alert("Opera browsers not supported, sorry...")
            return;
        }
        if (!strFound) alert("String '" + str + "' not found!")
        return;
    }

    // Subir archivo
    const mensajes = ref([]);
    const fileSubida = ref('');
    const alertaSubida = ref(0);
    const fileOrder = ref(null);
    const eventSubirArchivo = (rutaController) => {
        let formData = new FormData();
        //console.log(fileSubida.value);
        formData.append('file', fileSubida.value);
        axios.post(rutaController,
            formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        ).then(function (response) {
            //alertaSubida.value = 1;
            let respuesta = response.data;
            //let data = respuesta.data.data;
            if (respuesta.success) {
                //alertaSubida.value = 1;
                //mensajes.value = 'Total registros : '+(data.total-1)+'\nRegistrados : '+data.registered+'\nActualizados : '+data.updated;
                //limpiarVal(5000);
                showAlert(respuesta.message, 'success', 4)
                if (!respuesta.consistencia) messageError.value = respuesta.infoObservados
                if (respuesta.consistencia) messageError.value = null
                //this.$refs.fileOrder.value = null;// <-- Limpiar input file
                //fileOrder.value = null
                console.log(respuesta.debug)

            } else {
                showAlert(respuesta.message, 'danger', 16)
                //alertaSubida.value = 2;
                //mensajes.value = respuesta.data.message;
                //limpiarVal(3000);
            }
        }).catch(function () {
            //alertaSubida.value = 2;
            //limpiarVal(3000);
            showAlert('Registro actualizado', 'danger', 8)
        });
    }

    const handleFileUploadArchivo = (event) => {
        //fileSubida.value = this.$refs.fileSubida.files[0];
        fileSubida.value = event.target.files[0];
        //console.log(event.target.files[0]);
    }

    const isAlertActive = ref(false)
    const isAlertDangerActive = ref(false)
    const messageAlert = ref('')
    const messageLastAction = ref('')
    const messageError = ref('')
    /* const error = ref(0)
    const errors = ref([]) */
    const colorAlert = ref('success')
    const errormsg = ref(null)
    const errors = ref(0)
    const alertIndex = ref(0)

    const showAlert = (message = '', type, time = 1) => {

        messageAlert.value = message
        colorAlert.value = type// <-- Tipo define el color
        isAlertActive.value = true

        // grabar última acción
        messageLastAction.value = message

        /* if (color == 'danger') {
            isAlertDangerActive.value = true
        } else {
            isAlertActive.value = true
        } */
        setTimeout(() => {
            isAlertActive.value = false
            //messageAlert.value = '' <-- Comentar para que no halla error de prop indefined en el componente NotificationAlert
            /* if (color == 'danger') {
                isAlertDangerActive.value = false
            } else {
                isAlertActive.value = false
            } */
            errormsg.value = ref(null)
            errors.value = ref(0)
            alertIndex.value = ref(0)
            //isActionMassive.value = false
        }, time * 1000)// LRR bind(this)


    }

    /**
     * Section configuration
     * 
     */
    console.log(props.confConst)
    const tarifaForm = reactive({
        //matriculaGeneral: props.confConst ? props.confConst.matriculaGeneral : 0,
        matriculaInicial: props.confConst ? props.confConst.matriculaInicial : 0,
        matriculaPrimaria: props.confConst ? props.confConst.matriculaPrimaria : 0,
        matriculaSecundaria: props.confConst ? props.confConst.matriculaSecundaria : 0,
        pensionInicial: props.confConst ? props.confConst.pensionInicial : 0,
        pensionPrimaria: props.confConst ? props.confConst.pensionPrimaria : 0,
        pensionSecundaria: props.confConst ? props.confConst.pensionSecundaria : 0,
    });

    const tarifaSubmit = () => {
        // - LRR mainStore.setUser(profileForm);
        //setUser(profileForm);
        let ruta = 'constante-actualizar-configurations'
        Inertia.put(route(ruta, {
            //'id' : rowID.value,
            'typeConfiguration' : 'tarifa',
            //'matriculaGeneral' : tarifaForm.matriculaGeneral,
            'matriculaInicial' : tarifaForm.matriculaInicial,
            'matriculaPrimaria' : tarifaForm.matriculaPrimaria,
            'matriculaSecundaria' : tarifaForm.matriculaSecundaria,
            'pensionInicial' : tarifaForm.pensionInicial,
            'pensionPrimaria' : tarifaForm.pensionPrimaria,
            'pensionSecundaria' : tarifaForm.pensionSecundaria,
            }
        ))
    };

    const otherConfForm = reactive({
        automatizarAcceso: props.confConst ? props.confConst.automatizarAcceso : 0,
        diaValidarAccesoPago: props.confConst ? props.confConst.diaValidarAccesoPago : 1,
        fechaBloqueo: props.confConst ? props.confConst.fechaBloqueo : '',
        crearOrdenPagoEstudiante: props.confConst ? props.confConst.crearOrdenPagoEstudiante : 0,
        colaboradorPenalidadDescuentoMinuto: props.confConst ? props.confConst.colaboradorPenalidadDescuentoMinuto : '',
        pensionmoraxdia: props.confConst ? props.confConst.pensionmoraxdia : '',
        cobranzamensaje: props.confConst ? props.confConst.cobranzamensaje : '',
    });

    const otherConfSubmit = () => {
    //
    let ruta = 'constante-actualizar-configurations'
        Inertia.put(route(ruta, {
            //'id' : rowID.value,
            'typeConfiguration' : 'finanOtherConf',
            'automatizarAcceso' : otherConfForm.automatizarAcceso,
            'diaValidarAccesoPago' : otherConfForm.diaValidarAccesoPago,
            'fechaBloqueo' : otherConfForm.fechaBloqueo,
            'crearOrdenPagoEstudiante' : otherConfForm.crearOrdenPagoEstudiante,
            'colaboradorPenalidadDescuentoMinuto' : otherConfForm.colaboradorPenalidadDescuentoMinuto,
            'pensionmoraxdia' : otherConfForm.pensionmoraxdia,
            'cobranzamensaje' : otherConfForm.cobranzamensaje,
            }
        ))
    };

    // Desactivar acceso a todos los deudores
    const disabledAccesDeudores = () => {
        let arrayitems = props.listStudentsPtePagosRet
        let form = {
            'action': 'disabledAccessDeudores',
            'cr' : arrayitems// <-- Minimizar URI checkedRows
        };
        //console.log(arrayitems)
        let url = '/payementOrder/massaction';
        axios.put(url, form).then((response) => {
            let respuesta = response.data;
            console.log(respuesta)
            if (respuesta.success) {
                showAlert(respuesta.message, 'success', 4) 
                Inertia.reload({ only: ['listStudentsPtePagosRet','studentsDisabledAcces']})
            } else {
                showAlert(respuesta.message, 'danger', 16)
            }
            console.log('Desactivados Full');

        }).catch((error) => {
            console.log(error);
            
        });
    }

    const reloadProps = (contentArray = []) => {
        Inertia.reload({ only: contentArray})
    }

    const formatDate = (date, type='') => {
        //var now = new Date().toLocaleDateString()
        var date = new Date(date)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result =  (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        if (type == 'ISO') {
            result = date.getFullYear() + '-' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '-' +(date.getDate() > 9 ? '' : '0') + date.getDate()
        }
        return result
    }

    // Ejecutar
    const ejecutarConfirm = ref([])
    const crearStory = (type = 1) => {

        let ruta = 'student-store-story'
        Inertia.put(route(ruta, {
            //'id' : rowID.value,
            'anio' : props.anioEscolar,
            'type' : type

            }
        ))

    }

    const ejecutar = (type = '') => {

        let ruta = 'student-ejecutar'
        Inertia.put(route(ruta, {
            //'id' : rowID.value,
            'type' : type

            }
        ))

    }

    const showAyuda = ref([
        {'ordenpago': false},
        {'configuracion': false},
        {'cobranzas': false},
        {'facture': false}
    ])

</script>

<template>
    <Head title="Financiera" />

    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <!-- {{ confGlobal.value.UNENS_SEDE_NOMBRE }} v-if="$page.props.auth.user.id_rol == 1" -->
            <!-- <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Aulas asignadas 
            </h2> -->
            <div class="flex flex-wrap tab-m">
                <button v-if="isAdmin || isAdminCoord || isSecre" @click="(tab = 0, cleanVal())" :href="route('areaFinanciera')"
                    class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                    :class="[tab == 0 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                    <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Resumen</span>
                </button>
                <button v-if="isAdmin || isAdminCoord || isSecre" @click="(tab = 1, listarOrdenPago(), cleanVal())"
                    class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                    :class="[tab == 1 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                    <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Estado de cuenta</span>
                </button>
                <button v-if="confGlobal.value.FINANCIERA_USE_FACTURACION == 1 && (isAdmin || isSecre)" @click="(tab = 6, listarFacture(), cleanVal())"
                    class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                    :class="[tab == 6 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                    <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Facturas</span>
                </button>
                <button v-if="isAdmin" @click="(tab = 2, cleanVal())"
                    class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                    :class="[tab == 2 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                    <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Procesar pagos</span>
                </button>
                <button @click="(tab = 4, cleanVal(), reloadProps(['arrayDeudores','orderPtePagos','orderPtePagosRet']))"
                    class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                    :class="[tab == 4 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                    <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Cobranzas</span>
                </button>
                <button v-if="isAdmin" @click="(tab = 3, cleanVal())"
                    class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                    :class="[tab == 3 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                    <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Configuración</span>
                </button>
                <button v-if="isAdmin" @click="(tab = 5, cleanVal())"
                    class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                    :class="[tab == 5 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                    <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Tarea Anual</span>
                </button>
                <!-- <button v-if="!isPsico" @click="(tab=4, listarFileResources())" class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab==4 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                    <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Recursos de estudio</span>
                </button> -->
            </div>
        </template>

        <!-- <CardBoxModal v-model="showDialog" :title="(selectedEvent.title ? selectedEvent.title : 'Información del evento')"
            hasCancel>
            <strong>{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }} :
                {{ selectedEvent.start && selectedEvent.start.formatTime() }} -
                {{ selectedEvent.end && selectedEvent.end.formatTime() }}
            </strong>
            <p v-html="selectedEvent.contentFull" />
        </CardBoxModal> -->

        <div class="pb-12">
            <template v-if="tab == 0">
                <div class="mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-4">
                    <div v-if="isAdmin" class="grid grid-cols-1 lg:grid-cols-7 gap-4">
                        <div
                        class="col-span-7 lg:col-span-4 bg-white rounded-lg shadow-md  p-6 pt-10 bg-no-repeat bg-[url('/img/room/bg.png')] bg-contain bg-top h-full">
                            <div class="lg:pt-8 h-full">
                                <div>
                                    <h5 class="text-gray-900 text-xl font-bold pb-6">Estado de cuenta por periodo</h5>
                                </div>
                                <CardBox hasTable>
                                    <!-- {{ chartCalifications }} -->
                                    <div v-if="chartOrdenes" class="lg:h-[420px] h-[300px]">
                                        <line-chart :data="chartOrdenes" class="h-full" />
                                    </div>
                                </CardBox>
                            </div>
                        </div>

                        <div class="col-span-7 lg:col-span-3">
                            <div class="grid grid-cols-1 gap-4">
                                <div class="p-6 bg-white rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700 lg:h-[188px]">

                                    <!-- <div>
                                        <h1 class="text-base font-semibold mb-2">Cuadro de estados</h1>
                                    </div> -->
                                    
                                    <div class="lg:h-[calc(100%_-_35px)]">
                                        <hr>
                                        <div class="h-full">

                                            <div class="grid grid-cols-1 lg:grid-cols-2">
                                                
                                                <div class="flex flex-row items-center justify-center lg:py-0 py-4">
                                                    <div>
                                                        <h6 class="mb-1 w-full">Pte. Pago - En retraso</h6>
                                                        <div class="flex items-center">
                                                            <!-- <h2 class="font-bold text-4xl mr-3">-</h2> -->
                                                            <BaseIcon :path="mdiArrowUpCircle" :size="24"
                                                                class="text-lime-400 mr-2" title="Pensiones o matrícula que están pendientes de pago"/>
                                                            <p>{{ orderPtePagos }} </p>
                                                            <h2 class="font-bold text-4xl mr-3">&nbsp;-</h2>
                                                            <BaseIcon :path="mdiArrowDownCircle" :size="24"
                                                                class="text-rose-400 mr-2" title="Pensiones o matrícula que pasó la fecha de vencimiento"/>
                                                            <p>{{ orderPtePagosRet }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="flex flex-row items-center justify-center">
                                                    <div>
                                                        <h6 class="mb-1 w-full"> 
                                                            <BreezeDropdown>
                                                                <template #trigger>
                                                                    <span class="inline-flex rounded-md">
                                                                        <button type="button" class="inline-flex border border-transparent leading-4 rounded-md focus:outline-none transition ease-in-out duration-150">
                                                                            Deudores - Sin acceso
                                                                            <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                                                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                                            </svg>
                                                                        </button>
                                                                    </span>
                                                                </template>

                                                                <template v-if="isAdmin" #content>
                                                                    <!-- <BreezeDropdownLink :href="route('perfil')" as="button">
                                                                        Lista de deudores
                                                                    </BreezeDropdownLink>
                                                                    <BreezeDropdownLink :href="route('logout')" method="post" as="button"> -->
                                                                    <BreezeDropdownLink @click="disabledAccesDeudores()" >
                                                                        <span title="Todos lo que no tengan compromiso de pago o que tengan compromiso de pago vencidas">Desactivar acceso a los deudores</span>
                                                                    </BreezeDropdownLink>
                                                                </template>
                                                            </BreezeDropdown>
                                                        </h6>
                                                        <div class="flex items-center">
                                                            <BaseIcon :path="mdiArrowUpCircle" :size="24"
                                                                class="text-lime-400 mr-2" title="Alumnos no retirados que tienen pagos en retraso"/>
                                                            <p>{{ studentsPtePagosRet }} </p>
                                                            <h2 class="font-bold text-4xl mr-3">&nbsp;-</h2>
                                                            <BaseIcon :path="mdiArrowDownCircle" :size="24"
                                                                class="text-rose-400 mr-2" title="Alumnos no retirados sin acceso al sistema"/>
                                                            <p>{{ studentsDisabledAcces }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr>
                                            <div v-if="confGlobal.value.FINANCIERA_USE_FACTURACION == 1" class="grid grid-cols-1 lg:grid-cols-2">
                                                <div class="flex flex-row items-center justify-center">
                                                    <div title="Órdenes pagadas facturadas y por facturar">
                                                        <h6 class="mb-1 w-full">Facturado - No Facturado</h6>
                                                        <div class="flex items-center">
                                                            <p class="text-green-600 mr-2">{{ orderFacturado }}</p>
                                                            <h2 class="font-bold text-4xl mr-3">&nbsp;-</h2>
                                                            <p class="text-rose-600 mr-2">{{ orderNoFacturado }}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="flex flex-row items-center justify-center">
                                                    <div title="Estado de respuesta de Sunat">
                                                        <h6 class="mb-1 w-full">Aceptado - Enviado - Observado</h6>
                                                        <div class="flex items-center">
                                                            <p class="text-green-600 mr-2">{{ factureAceptado }}</p>
                                                            <h2 class="font-bold text-4xl mr-3">&nbsp;-</h2>
                                                            <p class="text-green-600 mr-2">{{ factureEnviado }}</p>
                                                            <h2 class="font-bold text-4xl mr-3">&nbsp;-</h2>
                                                            <p class="text-rose-600 mr-2">{{ factureObservado }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div class="p-6 bg-white rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700 lg:h-[364px]">
                                    <div>
                                        <h1 class="text-base font-semibold mb-2">Pendientes de pago vencidas</h1>
                                    </div>
                                    <div class="mt-4 lg:h-[calc(100%_-_35px)] ">
                                        <CardBox hasTable class="h-full">
                                            <!-- {{ chartCalifications }} -->
                                            <div v-if="chartPendientes" class="h-full">
                                                <bar-chart :data="chartPendientes" class="p-0" />
                                            </div>
                                        </CardBox>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <!-- Sección listas -->
                <div class="sm:px-6 lg:px-8 px-4 mx-auto pb-4">
                    <div class="grid gap-4 cols-1 xl:grid-cols-2 mb-6">
                        <div class=" bg-white rounded-lg shadow-lg p-6">
                            <div>
                                <h5 class="text-xl text-gray-900 font-bold mb-8 ml-3">Lista de alumnos Becados</h5>
                                <table class="min-w-full text-sm font-light table-responsive-wfull">
                                    <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600">
                                        <tr>
                                            <th scope="col" class="">#</th>
                                            <th scope="col" class="">Alumno</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="studentBecados.length" v-for="(client, index) in studentBecados"
                                            :key="client.id"
                                            class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                            <td class="whitespace-nowrap border-none font-medium border-r-0">{{ index + 1 }}
                                            </td>
                                            <td class="whitespace-nowrap border-none">{{ client.apellidos }} {{ client.nombres
                                            }}</td>

                                        </tr>
                                        <tr v-else class="border-b bg-white dark:border-neutral-500 dark:bg-neutral-600">
                                            <td class="whitespace-nowrap border-none font-medium" colspan="2"><span> No existen
                                                    registros …</span></td>

                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            <hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700">
                            <div class="mt-6">
                                <h5 class="text-xl text-gray-900 font-bold mb-8 ml-3">Deudores con compromiso de pago</h5>
                                <table class="min-w-full text-sm font-light table-responsive-wfull">
                                    <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600">
                                        <tr>
                                            <th scope="col" class="">#</th>
                                            <th scope="col" class="">Alumno</th>
                                            <th scope="col" class="">Fecha de compromiso</th>
                                            <!-- <th scope="col" class="">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="studentCompromisoPago.length" v-for="(client, index) in studentCompromisoPago"
                                            :key="client.id"
                                            class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                            <td class="whitespace-nowrap border-none font-medium border-r-0">{{ index + 1 }}
                                            </td>
                                            <td class="whitespace-nowrap border-none">{{ client.apellidos }} {{ client.nombres }}</td>
                                            <td class="whitespace-nowrap border-none" :class="(client.fecha_compromiso_pago && client.fecha_compromiso_pago < (formatDate(new Date(), 'ISO')) ? 'text-red-600' : '')"> {{ client.fecha_compromiso_pago }} </td>
                                        </tr>
                                        <tr v-else class="border-b bg-white dark:border-neutral-500 dark:bg-neutral-600">
                                            <td class="whitespace-nowrap border-none font-medium" colspan="3"><span> No existen
                                                    registros …</span></td>

                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            
                        </div>
                        <div class=" bg-white rounded-lg shadow-lg p-6">
                            <h5 class="text-xl text-gray-900 font-bold mb-8 ml-3">Lista de alumnos con Pensión Preferencial
                            </h5>
                            <table class="min-w-full text-sm font-light table-responsive-wfull">
                                <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600">
                                    <tr>
                                        <th scope="col" class="">#</th>
                                        <th scope="col" class="">Alumno</th>
                                        <th v-if="isAdmin" scope="col" class="">Pensión</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="studentPensionPref.length" v-for="(client, index) in studentPensionPref"
                                        :key="client.id"
                                        class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                        <td class="whitespace-nowrap border-none font-medium border-r-0">{{ index + 1 }}
                                        </td>
                                        <td class="whitespace-nowrap border-none">{{ client.apellidos }} {{ client.nombres
                                        }}</td>
                                        <td v-if="isAdmin" class="whitespace-nowrap border-none">{{ client.pension_preferencial }}</td>

                                    </tr>
                                    <tr v-else class="border-b bg-white dark:border-neutral-500 dark:bg-neutral-600">
                                        <td class="whitespace-nowrap border-none font-medium" colspan="3"><span> No existen
                                                registros …</span></td>

                                    </tr>


                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


            </template>
            <template v-else-if="tab == 1">
                <div class="mx-auto sm:px-6 lg:px-8 px-4 pt-12"><!--max-w-7xl-->
                    <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                        <div class="p-6 bg-white border-b border-gray-200">
                            <!--<div v-for="user in users" :key="user.id">
                                <Link :href="`/users/${user.id}`">
                                    {{ user.user}}
                                </Link>
                                <div>{{ user.name}}</div>
                            </div>-->
                            
                            <div class="mb-2">
                                <a href="#" class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" @click="showAyuda['ordenpago']=!showAyuda['ordenpago']">
                                    Ayuda<BaseIcon :path="mdiInformationOutline" size="15" /> 
                                </a>
                                <div v-if="showAyuda['ordenpago']">
                                    <ul>
                                        <li>ATENCIÓN: El estudiantes debe tener asignado el nivel y aula de estudio para ver sus órdenes de pago.</li>
                                        <li>El año de consulta actual es por default, si requiere de años anteriores cambiar el año.</li>
                                        <li>Si falta las órdenes sólo inicialice la orden de pago para agregar al que falta en la sección procesar pagos.</li>
                                        <li>Los registros Sin alta puede cambiar precios, establecer como Pte. Pago o eliminar (a menos que esté la opción de Pdte. de pago por default)</li>
                                        <li>Los registros Pte pago son los que ya están en alta. Y estos se pueden establecer como pagados.</li>
                                        <li>Sólo aplica el cambio de la fecha de vencimiento si el registro es Sin alta o pendiente de pago.</li>
                                        <li>Al facturar la fecha de emisión es la de hoy y valor total de IGV por default es 0 (exonerado), el cliente será el DNI del apoderado responsable de pagos.</li>
                                        <li>Sólo se puede facturar varias órdenes a un mismo estudiante, ya que se debe asignar al apoderado responsable de pago el comprobante.</li>
                                        <li>Matricular (Si matricula ya está pagado): Si el estudiante es antiguo y retirado, establece la fecha de matrícula por la del pago, cambia el estado de retirado a activo y aumenta un nivel o grado del estudiante a partir del nivel de 3 años</li>
                                        <li>Los txt de alta (P) se genera si filtra sin alta. Selecciona todos o uno por uno, una vez subido al banco debe actualizar estas como Pte. Pago</li>
                                        <li>Los txt de baja (E) se genera si filtra Pte. Pago. Selecciona todos o uno por uno, una vez subido al banco debe pasar a Sin alta y luego eliminarlo</li>
                                    </ul>
                                </div>
                                <!-- <li>Verificar que los totales con su decimales sean correctos</li> -->
                            </div>

                            <CardBox v-if="arrayOrdenPago && arrayOrdenPago.length" class="mb-6" has-table>
                                <!-- Tablesingle opciones: checkable -->
                                <div class="w-full overflow-x-auto relative">
                                    <TableAdvanced modulo="payementOrder" modulos="Estados de cuenta" :data="arrayOrdenPago"
                                        :fields="arrayOrdenPagoCol" ruta="payementOrder" exporteable searchAdvance
                                        :checkable="(isAdmin ? true : false)" :massDelete="(isAdmin ? true : false)" isSearchYear :userParam="userParamOrdenPago" :debugInertia="confGlobal.value.DEBUG_DISABLE_REFRESH_INERTIA == 1"/><!-- showTotales propiedad para PDF-->
                                </div>
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentEmpty />
                            </CardBox>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="tab == 2">
                <div class="mx-auto sm:px-6 lg:px-8 px-4 pt-12"><!--max-w-7xl-->
                    <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                        <div class="p-6 bg-white border-b border-gray-200">
                            <!--<div v-for="user in users" :key="user.id">
                                <Link :href="`/users/${user.id}`">
                                    {{ user.user}}
                                </Link>
                                <div>{{ user.name}}</div>
                            </div>-->

                            <div>
                                <p v-if="messageLastAction" class="p-6">
                                    <span v-text="'Última acción realizada: ' + messageLastAction" class="text-blue-600"></span>
                                </p>
                                <p v-if="messageError" class="mx-6 my-2">
                                    <span v-text="'Inconsistencia: ' + messageError" class="text-red-600"></span>
                                </p>

                                <!-- <span @click="showUpdateOrden=!showUpdateOrden">[ +  Actualizar órdenes de pago]</span> -->
                                <div
                                    class="bg-white tab tab-green w-full overflow-hidden border border-green-200 mb-6 rounded-lg">
                                    <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-actualizarPago"
                                        type="checkbox">
                                    <label @click="showUpdateOrden = !showUpdateOrden"
                                        class="block p-5 leading-normal cursor-pointer bg-green-100 content-center min-h-[66px]"
                                        for="tab-actualizarPago">
                                        <div
                                            class="my-auto inline-flex items-center min-h-[30px] w-[80%] sm:w-[90%] lg:w-[95%]">
                                            <span class="inline-flex font-semibold text-green-600">
                                                <BaseIcon :path="mdiClipboardEdit" :size="24" class="mr-3 " />
                                                Actualizar órdenes de pago
                                            </span>
                                        </div>

                                    </label>
                                    <div v-if="showUpdateOrden"
                                        class="tab-content overflow-hidden border-l-2 border-green-600  bg-white leading-normal p-6">
                                        <!-- <div
                                                class="card-head bg-rose-600 border-rose-600 text-white rounded-t-2xl flex flex-col p-6 transition-colors">
                                                Formato BBVA
                                                <p class="card-subtitle">Máximo 50 registros por archivo, los campos son <b>sensibles</b> a espacios, <b>minúsculas y mayúsculas</b>.</p>
                                            </div> -->
                                        <ul class="list-inside">
                                            <li>Formato BBVA</li>
                                            <li>Verificar que la consistencia de pagos sea correcta; cantidad de registros y totales</li>
                                            <li v-if="confGlobal.value.ACTUALIZAR_ACCESO_ALUMNO_FILE_BANCO == 1"> Desactivar accesos si el periodo de pago es menor al periodo anterior del periodo actual:
                                                 Si tiene fecha de compromiso de pago vencida. Si el día de hoy es mayor a {{ confGlobal.value.DIA_LIMITE_ACCESO_ALUMNO_FILE_BANCO }}. 
                                                 Si el pago es del periodo inferior al anterior entonces debe el último periodo por ello el acceso será desactivado hasta que pague el último.
                                            </li>
                                            <li v-if="confGlobal.value.ACTUALIZAR_ACCESO_ALUMNO_FILE_BANCO == 1">Activar accesos:
                                                 Si el periodo de pago es mayor o igual al periodo anterior del periodo actual.
                                                 Si el día actual es menor o igual a {{ confGlobal.value.DIA_LIMITE_ACCESO_ALUMNO_FILE_BANCO }} y el periodo de pago es mayor o igual al periodo anterior del anterior del periodo actual.
                                            </li>
                                        </ul>
                                        <div class="card-body pt-6">
                                            <div class="mb-6">
                                                <a href="/formats/txtupdatepagos.txt" target="_new"
                                                    class="btn btn-rose btn-ico"><span class="mr-2">Descargar formato de ejemplo</span>
                                                    <BaseIcon :path="mdiArrowDownBold" />
                                                </a>
                                            </div>
                                            <div class="mb-8">
                                                <label>
                                                    <input type="file" id="fileOrder" ref="fileOrder"
                                                        v-on:change="handleFileUploadArchivo" accept=".TXT, .txt"
                                                        class="w-full input-file input-file-slate" />
                                                </label>
                                            </div>
                                            <div class="mb-2">
                                                <button v-on:click="eventSubirArchivo('/payementOrder/importArchivo')"
                                                    class="btn btn-rose">Subir</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- <span @click="showCrearOrden=!showCrearOrden">[ +  Crear órdenes de pago]</span> -->
                                <!-- Crear órdenes de pago pensión y matrícula -->
                                <div
                                    class="bg-white tab tab-yellow w-full overflow-hidden border border-yellow-200 rounded-lg mb-6">
                                    <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-crearOrder"
                                        type="checkbox">
                                    <label @click="showCrearOrden = !showCrearOrden"
                                        class="block p-5 leading-normal cursor-pointer bg-yellow-100 content-center min-h-[66px]"
                                        for="tab-crearOrder">
                                        <div
                                            class="my-auto inline-flex items-center min-h-[30px] w-[80%] sm:w-[90%] lg:w-[95%]">
                                            <span class="inline-flex font-semibold text-yellow-600">
                                                <BaseIcon :path="mdiCashPlus" :size="24" class="mr-3 " />
                                                Crear órdenes de pago pensión, matrícula
                                            </span>
                                        </div>

                                    </label>
                                    <div v-if="showCrearOrden"
                                        class="tab-content overflow-hidden border-l-2 border-yellow-600  bg-white leading-normal p-6">
                                        <div>
                                            <ul>
                                                <li>Son {{ students.length }} alumnos activos no becados.</li>
                                                <li>En caso de generar matrícula del siguiente año, debe establecer a todos los alumnos nuevos que estudiaron este año a tipo antiguo, para establecer el costo del siguiente nivel si es que corresponde.</li>
                                                <li>Selecciones las opciones que desea crear órdenes de pago, el periodo 13 es
                                                    la matrícula, si no se refleja los cambios de tarifa, actualice su navegador.</li>
                                                <li>Matrícula inicial: <b>{{ confGlobal.value.PRECIO_MATRICULA_INICIAL }}</b>, Matrícula primaria: <b>{{ confGlobal.value.PRECIO_MATRICULA_PRIMARIA }}</b>,
                                                    Matrícula secundaria: <b>{{ confGlobal.value.PRECIO_MATRICULA_SECUNDARIA }}</b>, Pensión inicial:
                                                    <b>{{ confGlobal.value.PRECIO_PENSION_INICIAL }}</b>, Pensión primaria: <b>{{ confGlobal.value.PRECIO_PENSION_PRIMARIA }}</b>
                                                    , Pensión secundaria: <b>{{ confGlobal.value.PRECIO_PENSION_SECUNDARIA }}</b> </li>
                                                <!-- <BaseIcon
                                                        :path="mdiInformationOutline"
                                                        size="15"
                                                    /> Puede subir archivos PDF, DOCX, PPT, XLSX, JPG, PNG, con un límite máximo de {{  confGlobal.value.RESOURCE_LIMIT_UPLOAD_FILE }} KB. El nombre del recurso deben ser distinto a otro para no reemplazar a otro existente. -->
                                            </ul>
                                        </div>
                                        <div v-if="order13 === true">
                                            <div class="font-medium text-red-600">
                                                Asegúrese de la orden de pago por matrícula sea del año correcto (si se matricula para este año o para el próximo año).
                                            </div>
                                            <div> Vencimiento de matrícula 
                                                <input id="matriculaFVencimiento" name="matriculaFVencimiento" type="date" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="matriculaFVencimiento" autocomplete="off">
                                            </div>
                                        </div>
                                        <div>
                                            <div class="flex items-center my-4">
                                                <label class="mr-4"> Año </label>
                                                <!-- <BreezeInput id="inputname" type="text" class="w-[110px] lg:w-auto"
                                                    v-model="orderAnio" /> -->
                                                <select class="mb-3 rounded-lg" v-model="orderAnio">
                                                    <option :value="parseInt(anioEscolar)-3">{{ parseInt(anioEscolar)-3 }}</option>
                                                    <option :value="parseInt(anioEscolar)-2">{{ parseInt(anioEscolar)-2 }}</option>
                                                    <option :value="parseInt(anioEscolar)-1">{{ parseInt(anioEscolar)-1 }}</option>
                                                    <option :value="anioEscolar">{{ anioEscolar }}</option>
                                                    <option :value="parseInt(anioEscolar)+1">{{ parseInt(anioEscolar)+1 }}</option>
                                                </select>
                                                <label class="ml-4 mr-4"> Alumno </label>
                                                <!-- <select class="mb-3 rounded-lg" v-model="idStudentOrder">
                                                    <option value="0">Todos menos retirados y becados</option>
                                                    <option v-if="allStudents.length" v-for="student in allStudents" :value="student.id">{{ student.num_doc }} {{ student.apellidos }} {{ student.nombres }}</option>
                                                </select> -->

                                                <!-- El id deve ser siempre value - doc: https://vue3-select-component.vercel.app/demo/custom-option-slot.html -->
                                                <VueSelect v-if="allStudents.length" class="mb-3 rounded-lg"
                                                        v-model="idStudentOrder"
                                                        :options="allStudents"
                                                        :get-option-label="(option) => `(${option.num_doc}) ${option.apellidos} ${option.nombres}`"
                                                        placeholder="Todos menos retirados y becados"/>

                                                <!-- <label class="ml-4 mr-4" for="list_alumno-choice">Alumno</label>
                                                <input v-model="idStudentOrder" type="search" class="mb-3 rounded-lg" placeholder="Alumnos" list="list-alumnos" id="list_alumno-choice" name="list_alumno-choice" style="width: 300px;">
                                                <datalist
                                                    id="list-alumnos"
                                                    name="list-alumnos"
                                                    class="mb-3 rounded-lg">
                                                    <option value="0">Todos menos retirados y becados</option>
                                                    <option v-if="allStudents.length" v-for="student in allStudents" :value="student.id">{{ student.num_doc }} {{ student.apellidos }} {{ student.nombres }}</option>
                                                </datalist> -->
                                                
                                            </div>

                                        </div>

                                        <div class="mt-1 w-full label-clean xl:flex flex-row justify-between grid lg:grid-cols-6 sm:grid-cols-2 grid-cols-1">
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxmatricula" class="mr-2" v-model="order13" />
                                                <label for="chxmatricula" class="">Matricula</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxmarzo" class="mr-2" v-model="order03" />
                                                <label for="chxmarzo">Marzo</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxabril" class="mr-2" v-model="order04" />
                                                <label for="chxabril">Abril</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxmayo" class="mr-2" v-model="order05" />
                                                <label for="chxmayo">Mayo</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxjunio" class="mr-2" v-model="order06" />
                                                <label for="chxjunio">Junio</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxjulio" class="mr-2" v-model="order07" />
                                                <label for="chxjulio">Julio</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxagosto" class="mr-2" v-model="order08" />
                                                <label for="chxagosto">Agosto</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxsetiembre" class="mr-2" v-model="order09" />
                                                <label for="chxsetiembre">Setiembre</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxoctubre" class="mr-2" v-model="order10" />
                                                <label for="chxoctubre">Octubre</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxnoviembre" class="mr-2" v-model="order11" />
                                                <label for="chxnoviembre">Noviembre</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxdiciembre" class="mr-2" v-model="order12" />
                                                <label for="chxdiciembre">Diciembre</label>
                                            </div>

                                        </div>
                                        <div class="mt-4 block w-full">
                                            <span v-if="order13 && !matriculaFVencimiento" class="font-medium text-red-600">Debe asignar un año de matrícula</span>
                                            <span v-else-if="orderAnio < anioEscolar && idStudentOrder == 0" class="font-medium text-red-600">Para crear órdenes de años anteriores debe escoger un alumno</span>
                                            <BaseButton v-else :icon="mdiPlusCircle" color="info" icon-size="20" small
                                                label="Inicializar órdenes de pago" @click.once="iniciarOrdenPago()" />
                                        </div>
                                    </div>
                                </div>

                                <!-- Crear órdenes de pago otros FINANCIERA_USE_ORDEN_PAGO_OTROS -->
                                <div v-if="(confGlobal.value.FINANCIERA_USE_ORDEN_PAGO_OTROS == 1)" class="bg-white tab tab-blue w-full overflow-hidden border border-blue-200 rounded-lg mb-6">
                                    <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-crearOrderVarios"
                                        type="checkbox">
                                    <label @click="showCrearOrdenVarios = !showCrearOrdenVarios"
                                        class="block p-5 leading-normal cursor-pointer bg-blue-100 content-center min-h-[66px]"
                                        for="tab-crearOrderVarios">
                                        <div
                                            class="my-auto inline-flex items-center min-h-[30px] w-[80%] sm:w-[90%] lg:w-[95%]">
                                            <span class="inline-flex font-semibold text-blue-600">
                                                <BaseIcon :path="mdiCashPlus" :size="24" class="mr-3 " />
                                                Crear órdenes de pago de tipo varios
                                            </span>
                                        </div>

                                    </label>
                                    <div v-if="showCrearOrdenVarios" class="tab-content overflow-hidden border-l-2 border-blue-600  bg-white leading-normal p-6">
                                        <div>
                                            <ul>
                                                <li>Aquí puede generar otros tipo de órdenes, por ejemplo uniformes, libros, pagos a cuenta u otros seguimiento de pagos.</li>
                                            </ul>
                                        </div>
                                        <div class="min-w-[400px] overflow-x-auto">
                                            <div class="flex flex-row items-center my-4 gap-4 pb-4 xl:pb-2">
                                                <div class="basis-1/2">
                                                    <label> Alumno </label>
                                                    <!-- <select class="w-full min-w-[200px] border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="idStudentOrder">
                                                        <option value="0">Seleccionar estudiante</option>
                                                        <option v-if="allStudents.length" v-for="student in allStudents" :value="student.id">{{ student.num_doc }} {{ student.apellidos }} {{ student.nombres }}</option>
                                                    </select> -->

                                                    <!-- El id deve ser siempre value - doc: https://vue3-select-component.vercel.app/demo/custom-option-slot.html -->
                                                    <VueSelect v-if="allStudents.length" class="w-full min-w-[200px] border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1"
                                                        v-model="idStudentOrder"
                                                        :options="allStudents"
                                                        :get-option-label="(option) => `(${option.num_doc}) ${option.apellidos} ${option.nombres}`"
                                                        placeholder="Seleccionar estudiante"/>
                                                </div>

                                                <!-- <label class="ml-4 mr-4" for="list_alumno-choice">Alumno</label>
                                                <input v-model="idStudentOrder" type="search" class="mb-3 rounded-lg" placeholder="Alumnos" list="list-alumnos" id="list_alumno-choice" name="list_alumno-choice" style="width: 300px;">
                                                <datalist
                                                    id="list-alumnos"
                                                    name="list-alumnos"
                                                    class="mb-3 rounded-lg">
                                                    <option value="0">Todos menos retirados y becados</option>
                                                    <option v-if="allStudents.length" v-for="student in allStudents" :value="student.id">{{ student.num_doc }} {{ student.apellidos }} {{ student.nombres }}</option>
                                                </datalist> -->

                                                <div  class="basis-1/4">
                                                    <label for="fechaEmision">Fecha emisión </label> 
                                                    <input id="fechaEmision" name="fechaEmision" type="date" class="w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="fechaEmision" autocomplete="off">
                                                </div>
                                                <div  class="basis-1/4">
                                                    <label for="fechaVencimiento">Fecha Vencimeinto </label> 
                                                    <input id="fechaVencimiento" name="fechaVencimiento" type="date" class="w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="fechaVencimiento" autocomplete="off">
                                                </div>

                                                

                                                <!-- label class="mr-4"> Año </label>
                                                
                                                <select class="mb-3 rounded-lg" v-model="orderAnio">
                                                    <option :value="parseInt(anioEscolar)-3">{{ parseInt(anioEscolar)-3 }}</option>
                                                    <option :value="parseInt(anioEscolar)-2">{{ parseInt(anioEscolar)-2 }}</option>
                                                    <option :value="parseInt(anioEscolar)-1">{{ parseInt(anioEscolar)-1 }}</option>
                                                    <option :value="anioEscolar">{{ anioEscolar }}</option>
                                                    <option :value="parseInt(anioEscolar)+1">{{ parseInt(anioEscolar)+1 }}</option>
                                                </select> -->

                                                
                                                
                                            </div>
                                            <div class="flex flex-row items-center my-4 gap-4 pb-4 xl:pb-2">
                                                <div  class="basis-1/4">
                                                    <label for="tipodeorder">Tipo de orden</label> 
                                                    <select id="tipodeorder" @click="listarOrdenPago()"  class="w-full min-w-[200px] border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="tipoDeOrder">
                                                        <option value="0">Otro</option>
                                                        <option value="1">Pago a cuenta</option>
                                                    </select>
                                                </div>
                                                <div v-if="tipoDeOrder == 1 && idStudentOrder > 0" class="basis-1/4"> 
                                                    <label for="tipodeorder">Orden de origen</label> 
                                                    <select id="tipodeorder" class="w-full min-w-[200px] border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="idOrderOrigen">
                                                        <option value="0">Escoger orden a descontar</option>
                                                        <option v-if="arrayOrdenPago.length" v-for="order in arrayOrdenPago" :value="order.id">{{ order.label + ' S/ ' + order.total_ttc }}</option>
                                                    </select>
                                                </div>
                                                <div  class="basis-1/4">
                                                    <label for="orderVariosLabel">Etiqueta/Referencia </label> 
                                                    <input id="orderVariosLabel" name="orderVariosLabel" type="text" class="w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="orderVariosLabel" autocomplete="off">
                                                </div>

                                                <div  class="basis-1/4">
                                                    <label for="orderVariosAmount">Monto </label> 
                                                    <input id="orderVariosAmount" name="orderVariosAmount" type="number" class="w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="orderVariosAmount" autocomplete="off">
                                                </div>
                                            </div>
                                        </div>

                                        
                                        <div class="mt-4 block w-full">
                                            <span v-if="errorOrderVarios" class="font-medium text-red-600">Debe ingresar los campos requeridos</span>
                                            <span v-if="tipoDeOrder == 1 && idOrderOrigen <= 0" class="font-medium text-red-600">Si es un pago a cuenta, debe escoger una orden de origen del estudiante para el descuento de esa orden</span>
                                            <BaseButton v-else :icon="mdiPlusCircle" color="info" icon-size="20" small
                                                label="Registrar orden de pago" @click.once="iniciarOrdenPagoVarios()" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </template>
            <!-- Configuración -->
            <template v-else-if="tab == 3">
                <div class="mx-auto sm:px-6 lg:px-8 px-4 pt-12"><!--max-w-7xl-->
                    <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                        <div class="p-6 bg-white border-b border-gray-200">
                            <!--<div v-for="user in users" :key="user.id">
                                <Link :href="`/users/${user.id}`">
                                    {{ user.user}}
                                </Link>
                                <div>{{ user.name}}</div>
                            </div>-->

                            <div>
                                <div class="mb-2">
                                    <ul>
                                        <li>Se muestran las tarifas de matrícula y pensión por defecto.</li>
                                        <li>Debe establecer los montos actuales antes de inicializar órdenes de pago para que estas se creen con la tarifa actual.</li>
                                        <li>Si hay dos empresas debe asignar el nivel educativo con la entidad que corresponde en panel de configuración, niveles (sólo se toma en cuenta el nivel padre)</li>
                                        <li v-if="pinSecurity != confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY">Para realizar cambios ingrese el Pin de seguridad (no se verá lo que escribe) <input id="pin_security" name="pin_security" type="text" class="text-transparent border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="pinSecurity" autocomplete="off" title="Si selecciona el campo podrá ver lo que escribió"></li>
                                    </ul>
                                </div>
                                <div>
                                    <BreezeValidationErrors class="mb-4" />
                                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                        <CardBox is-form @submit.prevent="tarifaSubmit">
                                            <!-- <FormField label="Avatar" help="Max 500kb">
                                                <FormFilePicker label="Upload" />
                                            </FormField> -->

                                            <!-- <FormField label="Matrícula general" help="">
                                                <FormControl
                                                v-model="tarifaForm.matriculaGeneral"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="matriculaGeneral"
                                                required
                                                autocomplete="matriculaGeneral"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField> -->
                                            <FormField label="Matrícula inicial" help="">
                                                <FormControl
                                                v-model="tarifaForm.matriculaInicial"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="matriculaInicial"
                                                required
                                                autocomplete="matriculaInicial"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>
                                            <FormField label="Matrícula primaria" help="">
                                                <FormControl
                                                v-model="tarifaForm.matriculaPrimaria"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="matriculaPrimaria"
                                                required
                                                autocomplete="matriculaPrimaria"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>
                                            <FormField label="Matrícula secundaria" help="">
                                                <FormControl
                                                v-model="tarifaForm.matriculaSecundaria"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="matriculaSecundaria"
                                                required
                                                autocomplete="matriculaSecundaria"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField label="Pensión Inicial" help="">
                                                <FormControl
                                                v-model="tarifaForm.pensionInicial"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="pensionInicial"
                                                required
                                                autocomplete="pensionInicial"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>
                                            <FormField label="Pensión Primaria" help="">
                                                <FormControl
                                                v-model="tarifaForm.pensionPrimaria"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="pensionPrimaria"
                                                required
                                                autocomplete="pensionPrimaria"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>
                                            <FormField label="Pensión Secundaria" help="">
                                                <FormControl
                                                v-model="tarifaForm.pensionSecundaria"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="pensionSecundaria"
                                                required
                                                autocomplete="pensionSecundaria"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <template #footer>
                                                <BaseButtons>
                                                    <BaseButton v-if="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? true : false)" color="info" type="submit" label="Guardar" />
                                                    <!-- <BaseButton color="info" label="Options" outline /> -->
                                                </BaseButtons>
                                            </template>
                                        </CardBox>

                                        <CardBox is-form @submit.prevent="otherConfSubmit">
                                            <!-- <FormField
                                                label="Current password"
                                                help="Ingresar password actual"
                                            >
                                                <FormControl
                                                v-model="passwordForm.password_current"
                                                :icon="mdiAsterisk"
                                                name="password_current"
                                                type="password"
                                                required
                                                autocomplete="current-password"
                                                />
                                            </FormField>

                                            <BaseDivider /> -->

                                            <FormField label="Automatizar Acceso" help="Actualizar acceso del alumno desde txt de pagos">
                                                <FormControl
                                                v-model="otherConfForm.automatizarAcceso"
                                                :icon="mdiCog"
                                                name="automatizarAcceso"
                                                type="yesno"
                                                required
                                                autocomplete="automatizarAcceso"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField label="Día límite para desactivar accesos" help="Luego de este día, al subir los txt de pagos se desactivarán los usuarios">
                                                <FormControl
                                                v-model="otherConfForm.diaValidarAccesoPago"
                                                :icon="mdiCog"
                                                name="diaValidarAccesoPago"
                                                type="number"
                                                required
                                                autocomplete="diaValidarAccesoPago"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField label="Fecha de Bloqueo" help="Fecha de bloqueo recaudo banco en txt de altas o bajas, sin espacios o carácteres especiales (ejem. 20301231)">
                                                <FormControl
                                                v-model="otherConfForm.fechaBloqueo"
                                                :icon="mdiCog"
                                                name="fechaBloqueo"
                                                type="text"
                                                required
                                                autocomplete="fechaBloqueo"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField label="Crear orden de pago al crear estudiante" help="Al crear un estudiante mostrar la opción de crear sus órdenes de pago (matrícula, pensión)">
                                                <FormControl
                                                v-model="otherConfForm.crearOrdenPagoEstudiante"
                                                :icon="mdiCog"
                                                name="crearOrdenPagoEstudiante"
                                                type="yesno"
                                                required
                                                autocomplete="crearOrdenPagoEstudiante"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>
                                            
                                            <FormField label="Colaborador, penalidad descuento por minuto" help="Asistencia, penalidad descuento por minuto (tardanza y salida temprano)">
                                                <FormControl
                                                v-model="otherConfForm.colaboradorPenalidadDescuentoMinuto"
                                                :icon="mdiCog"
                                                name="colaboradorPenalidadDescuentoMinuto"
                                                type="text"
                                                required
                                                autocomplete="colaboradorPenalidadDescuentoMinuto"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField v-if="confGlobal.value.FINANCIERA_USE_MORA == 1" label="Pensión, mora por día de atraso" help="Cobranzas, se sumará el monto desde la fecha de vencimiento hasta la actual.">
                                                <FormControl
                                                v-model="otherConfForm.pensionmoraxdia"
                                                :icon="mdiCog"
                                                name="pensionmoraxdia"
                                                type="text"
                                                required
                                                autocomplete="pensionmoraxdia"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField label="Mensaje por defecto de cobranza" help="Cobranzas, se puede usar las palabras reservadas: __APODERADO_NOMBRE__, __REF_DEUDAS__, __TOT_PENSION__, __TOT_MORA__, __TOT_OTROS__, __TOT_ACTUAL__">
                                                <FormControl
                                                v-model="otherConfForm.cobranzamensaje"
                                                :icon="mdiCog"
                                                name="cobranzamensaje"
                                                type="textarea"
                                                required
                                                autocomplete="cobranzamensaje"
                                                :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <template #footer>
                                                <BaseButtons>
                                                    <BaseButton v-if="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? true : false)" type="submit" color="info" label="Guardar" />
                                                    <!-- <BaseButton color="info" label="Options" outline /> -->
                                                </BaseButtons>
                                            </template>
                                        </CardBox>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </template>
            <!-- Deudores -->
            <template v-else-if="tab == 4">
                <div class="mx-auto sm:px-6 lg:px-8 px-4 pt-12"><!--max-w-7xl-->
                    <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                        <div class="p-6 bg-white border-b border-gray-200">
                            <!--<div v-for="user in users" :key="user.id">
                                <Link :href="`/users/${user.id}`">
                                    {{ user.user}}
                                </Link>
                                <div>{{ user.name}}</div>
                            </div>-->
                            <div>
                                <div class="mb-2">
                                    <a href="#" class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" @click="showAyuda['cobranzas']=!showAyuda['cobranzas']">
                                        Ayuda<BaseIcon :path="mdiInformationOutline" size="15" /> 
                                    </a>
                                    <div v-if="showAyuda['cobranzas']">
                                        <li>Sólo se muestran los deudores del año escolar actual.</li>
                                        <li>El número de orden puede variar en caso que halla menos o más deudores de un día a otro.</li>
                                        <li>El contenido del mensaje es el inicio para que usted agregue más contenido si lo considera.</li>
                                        <li>Para enviar mensaje por Whatsapp desde la computadora debe tener instalado el Whatsapp de escritorio.</li>
                                        <li>Se muestra el código de aula para mantener el orden Ascendente. El orden por defecto es de Aula sección -> apellidos -> nombres.</li>
                                        <li>El sufijo Ret. quiere decir que el estudiante está retirado.</li>
                                    </div>
                                    
                                </div>

                            </div>

                            <CardBox v-if="arrayDeudores.length" class="mb-6" has-table>
                                <!-- Tablesingle opciones: checkable -->
                                <div class="w-full overflow-x-auto relative">
                                    <TableAdvanced modulo="cobranzas" modulos="Deudores" :data="arrayDeudores"
                                        :fields="arrayDeudoresCol" ruta="payementOrder" exporteable showIndex
                                        :userParam="userParamDeudores" /><!-- showTotales propiedad para PDF -> isSearchYear no se usa ya que no es una funcion index -->
                                </div>
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentEmpty />
                            </CardBox>
                        </div>
                    </div>
                </div>
            </template>
            <!-- Tareas anuales -->
            <template v-else-if="tab == 5">
                <div class="mx-auto sm:px-6 lg:px-8 px-4 pt-12"><!--max-w-7xl-->
                    <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                        <div class="p-6 bg-white border-b border-gray-200">
                            <!--<div v-for="user in users" :key="user.id">
                                <Link :href="`/users/${user.id}`">
                                    {{ user.user}}
                                </Link>
                                <div>{{ user.name}}</div>
                            </div>-->
                            <div>
                                <div class="mb-2">
                                    <h2><span class="text-red-500">CUIDADO: </span>Procesos para inicializar un nuevo año escolar, una vez que se realicen los pasos no hay marcha atrás y si realiza los pasos por error no habrá nada que podamos hacer.</h2>
                                </div>
                                <p v-if="pinSecurity != confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY">Para realizar cambios ingrese el Pin de seguridad (no se verá lo que escribe) <input id="pin_security" name="pin_security" type="text" class="text-transparent border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="pinSecurity" autocomplete="off" title="Si selecciona el campo podrá ver lo que escribió"></p>
                            </div>

                            <CardBox class="mb-6" :class="pinSecurity != confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? 'pointer-events-none' : ''" has-table>
                                <!-- lg:justify-end -->
                                <div class="w-full overflow-x-auto">
                                    <ul>
                                        <li> 1. Esto creará o actualizará la historia del estudiante activo del año actual</li>
                                        <BaseButtons type="justify-start" no-wrap>
                                            <BaseButton
                                                color="info"
                                                :label="'Ejecutar Historia ' + anioEscolar + ' anual antiguos y nuevos'"
                                                small
                                                @click="(ejecutarConfirm['storyantiguos']=1)"
                                            />
                                            <BaseButton
                                            v-if = "ejecutarConfirm['storyantiguos'] == 1"
                                                color="warning"
                                                label="Confirmar"
                                                small
                                                @click="(crearStory(1), (ejecutarConfirm['storyantiguos']=0))"
                                            />
                                        </BaseButtons>
                                        <br>
                                        <li>2. Para empezar a matricular un nuevo año escolar se debe establecer a todos los estudiantes nuevos como antiguos (los únicos nuevos serán los matriculados a partir de ahora).</li>
                                        <BaseButtons type="justify-start" no-wrap>
                                            
                                            <BaseButton
                                                color="info"
                                                label="Establecer todos los estudiantes nuevos a antiguos"
                                                small
                                                @click="(ejecutarConfirm['allantiguos']=1)"
                                            />
                                            <BaseButton
                                            v-if = "ejecutarConfirm['allantiguos'] >= 1"
                                                color="warning"
                                                label="Confirmar"
                                                small
                                                @click="(ejecutarConfirm['allantiguos']=2)"
                                            />

                                            <BaseButton
                                            v-if = "ejecutarConfirm['allantiguos'] >= 2"
                                                color="danger"
                                                label="Re Confirmar"
                                                small
                                                @click="(ejecutarConfirm['allantiguos']=3)"
                                            />

                                            <BaseButton
                                            v-if = "ejecutarConfirm['allantiguos'] == 3"
                                                color="warning"
                                                label="Todos serán antiguos"
                                                small
                                                @click="(ejecutar('allantiguos'), (ejecutarConfirm['allantiguos']=0))"
                                            />
                                            
                                        </BaseButtons>
                                        <br>
                                        <li>3. Esto creará la historia del estudiante del nuevo año escolar o actualizará su estado</li>
                                        <BaseButtons type="justify-start" no-wrap>
                                            <BaseButton
                                                color="info"
                                                :label="'Ejecutar Historia ' + (parseInt(anioEscolar)+1) + ' anual nuevos'"
                                                small
                                                @click="(ejecutarConfirm['storynuevos']=1)"
                                            />
                                            <BaseButton
                                            v-if = "ejecutarConfirm['storynuevos'] == 1"
                                                color="warning"
                                                label="Confirmar"
                                                small
                                                @click="(crearStory(0), (ejecutarConfirm['storynuevos']=0))"
                                            />
                                        </BaseButtons>
                                        <br>
                                        <li>4. Esto se realizará al finalizar el año escolar. Todos los estudiantes antiguos activos se cambiarán a retirados</li>
                                        <BaseButtons type="justify-start" no-wrap>
                                            <BaseButton
                                                color="info"
                                                label="Establecer todos los estudiantes activos como retirados"
                                                small
                                                @click="(ejecutarConfirm['allretirados']=1)"
                                            />

                                            <BaseButton
                                            v-if = "ejecutarConfirm['allretirados'] == 1"
                                                color="warning"
                                                label="Confirmar"
                                                small
                                                @click="(ejecutar('allretirados'), (ejecutarConfirm['allretirados']=0))"
                                            />
                                            
                                        </BaseButtons>
                                        <br>
                                        <li>5. Aperturar ciclos académicos del año actual (Bimestres)</li>
                                        <BaseButtons type="justify-start" no-wrap>
                                            <BaseButton
                                                color="info"
                                                label="Aperturar ciclo académico actual"
                                                small
                                                @click="(ejecutarConfirm['aperturarciclos']=1)"
                                            />

                                            <BaseButton
                                            v-if = "ejecutarConfirm['aperturarciclos'] == 1"
                                                color="warning"
                                                label="Confirmar"
                                                small
                                                @click="(ejecutar('aperturarciclos'), (ejecutarConfirm['aperturarciclos']=0))"
                                            />
                                            
                                        </BaseButtons>
                                    </ul>
                                </div>

                            </CardBox>
                            
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="tab == 6">
                <div class="mx-auto sm:px-6 lg:px-8 px-4 pt-12"><!--max-w-7xl-->
                    <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                        <div class="p-6 bg-white border-b border-gray-200">
                            <!--<div v-for="user in users" :key="user.id">
                                <Link :href="`/users/${user.id}`">
                                    {{ user.user}}
                                </Link>
                                <div>{{ user.name}}</div>
                            </div>-->
                            
                            <div class="mb-2">
                                <a href="#" class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" @click="showAyuda['facture']=!showAyuda['facture']">
                                    Ayuda<BaseIcon :path="mdiInformationOutline" size="15" /> 
                                </a>
                                <div v-if="showAyuda['facture']">
                                    <li>El año de consulta actual es por default, si requiere de años anteriores cambiar el año.</li>
                                    <li>Las boletas de venta electrónica se envían automáticamente a Sunat por resumen diario al día siguiente de su emisión.</li>
                                    <li>Para dar de baja un comprobante, este debe estar aceptado por Sunat previamente.</li>
                                    
                                </div>
                                <!-- <li>Verificar que los totales con su decimales sean correctos</li> -->
                            </div>

                            <CardBox v-if="arrayFacture && arrayFacture.length" class="mb-6" has-table>
                                <!-- Tablesingle opciones: checkable -->
                                <div class="w-full overflow-x-auto relative">
                                    <TableAdvanced modulo="facture" modulos="Facturas/Boletas" :data="arrayFacture"
                                        :fields="arrayFactureCol" ruta="facture" exporteable searchAdvance
                                        :checkable="(isAdmin ? true : false)" isSearchYear :userParam="userParamFacture" :debugInertia="confGlobal.value.DEBUG_DISABLE_REFRESH_INERTIA == 1"/><!-- showTotales propiedad para PDF-->
                                </div>
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentEmpty />
                            </CardBox>
                        </div>
                    </div>
                </div>
            </template>
            <!-- <template v-else-if="tab==4">
                <div class="mx-auto sm:px-6 lg:px-8 px-4 pt-12">
                    <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                        <div class="p-6 bg-white border-b border-gray-200">
                            
                            <div>
                                <Link :href="route('file-create', {'origin_type': 'file_resourceforcourse'})">
                                    <BaseButton
                                        color="info"
                                        :icon="mdiPlusCircle"
                                        small
                                        label=" Nuevo"
                                        class="float-right"
                                    />
                                </Link>
                            </div>
                            
                            <CardBox v-if="arrayFileResources.length" class="mb-6" has-table>
                               
                                <div class="w-full overflow-x-auto relative">
                                    <TableAdvanced modulo="Documento" modulos="Recursos de estudio" :data="arrayFileResources" :fields="arrayFileResourcesCol" ruta="file"
                                        updateable/>
                                </div>
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentLoad />
                            </CardBox>
                        </div>
                    </div>
                </div>
            </template> -->
        </div>
    </BreezeAuthenticatedLayout>
</template>
<style lang="css" scoped>
    /* :deep(.vue-select .custom-value) {
    display: flex;
    align-items: center;
    gap: 6px;
    }

    :deep(.vue-select .custom-option) {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #171717;
    font-weight: 500;
    font-size: 16px;
    }

    :deep(.vue-select .custom-option small) {
    color: #525252;
    font-weight: 500;
    font-size: 14px;
    } */
</style>
